import React, { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { differenceInMilliseconds, isValid } from "date-fns";
import { authRefreshFailure } from "../../actions/userActions";
import ConfirmModal from "../common/ConfirmModal";
import { showModal } from "../../actions/modalActions";

const SESSION_EXPIRED_MODAL_ID = "sessionExpiredModal";

export function SessionExpiredModal() {
  const authState = useSelector((state) => state.reducers.auth);
  const dispatch = useDispatch();

  const refreshTokenExpires = authState?.refreshTokenExpires;

  const logoutUser = useCallback(() => {
    dispatch(authRefreshFailure());
  }, [dispatch]);

  useEffect(() => {
    let timer;
    const expirationDate = new Date(refreshTokenExpires);
    if (isValid(expirationDate)) {
      const diffInMs = differenceInMilliseconds(expirationDate, new Date());
      timer = setTimeout(() => {
        dispatch(showModal(SESSION_EXPIRED_MODAL_ID));
      }, diffInMs);
    } else {
      logoutUser();
    }

    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [refreshTokenExpires, logoutUser, dispatch]);

  return (
    <ConfirmModal
      closeOnClick={false}
      id={SESSION_EXPIRED_MODAL_ID}
      title="Session Expired"
      body="Your session has expired. Please login again."
      close={logoutUser}
      showCancel={false}
    />
  );
}
